export type WordExerciseStateModel = typeof wordExerciseStateModel;

const wordExerciseStateModel = {
  currentWord: '',
  nextLetter: '',
  currentWordInArray: [],
  currentWordChoices: [],
  blankedLetters: [],
  currentLetterPosition: 0,
  toNextWord: false,
  Alphabet: [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ],
};

export default wordExerciseStateModel;
